module.exports = __webpack_public_path__ + "img/ico_detail.6418be97.svg";